import { ColumnChooserModel } from "../../common/ColumnChooserModel"
import { ColumnFilterModel } from "../../common/ColumnFilterModel"

export interface GetBulkPriceSchemeListRequest {
    searchTerm: string
    skip: number
    take: number
    sortColumn?: string
    sortDirection?: string
    columnChooser: ColumnChooserModel[] | undefined
    currentPage: number
    columnFilters: ColumnFilterModel[]
    /** Excel "Seçilenler" için işaretli şablonlar. */
    ids?: string[]
}

export const initialGetBulkPriceSchemeListRequest: GetBulkPriceSchemeListRequest = {
    searchTerm: '',
    skip: 0,
    take: 50,
    currentPage: 1,
    sortColumn: undefined,
    sortDirection: undefined,
    columnChooser: undefined,
    columnFilters: []
}

export interface ApplyEscalationItemRequest {
    costItemId: string
    /** Bu kalemdeki artış oranı (%). Ağırlıkla çarpılır. */
    rate?: string
    /** Bu kalemden gelen tutar. Ağırlıkla ÇARPILMAZ, doğrudan eklenir. */
    amount?: string
}

export interface ApplyEscalationRequest {
    schemes: BulkPriceSchemeRef[]
    /** İşaretli anlaşmalar. Boşsa şablonların bütün anlaşmaları. */
    agreementIds?: string[]
    startDate?: string
    endDate?: string
    /** "Tüm Maliyet Kalemlerine" anahtarı. */
    allCostItems: boolean
    rate?: string
    amount?: string
    description?: string
    items: ApplyEscalationItemRequest[]
}

export interface GetPriceEscalationHistoryRequest {
    schemes: BulkPriceSchemeRef[]
    skip?: number
    take?: number
}

/** Detayı istenen şablon: hangi modülden, hangi kayıt. */
export interface BulkPriceSchemeRef {
    moduleKey: string
    schemeId: string
}

export interface GetBulkPriceAgreementListRequest {
    schemes: BulkPriceSchemeRef[]
    skip: number
    take: number
    sortColumn?: string
    sortDirection?: string
    columnChooser: ColumnChooserModel[] | undefined
    currentPage: number
    columnFilters: ColumnFilterModel[]
    /** Excel "Seçilenler". */
    ids?: string[]
    /** Excel "Aktif": yalnız bugün geçerli anlaşmalar. */
    onlyActive?: boolean
}

export const initialGetBulkPriceAgreementListRequest: GetBulkPriceAgreementListRequest = {
    schemes: [],
    skip: 0,
    take: 50,
    currentPage: 1,
    sortColumn: undefined,
    sortDirection: undefined,
    columnChooser: undefined,
    columnFilters: [],
    onlyActive: false
}
